// extracted by mini-css-extract-plugin
export default {"wrapper":"MyPost_wrapper__CHcOz","mypost_textarea":"MyPost_mypost_textarea__4pPsS","button_area":"MyPost_button_area__hjrR1","posts":"MyPost_posts__1XNG4"};